var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArea = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.75 3a.75.75 0 0 0-1.2-.6L8.723 5.27a.25.25 0 0 1-.096.045l-4.29.953a.75.75 0 0 0-.565.55l-1.5 6A.75.75 0 0 0 3 13.75h10a.75.75 0 0 0 .75-.75V3zM9.623 6.47L12.25 4.5v1.19l-2.075 2.074a.25.25 0 0 1-.122.067l-4.216.937a.75.75 0 0 0-.488.36l-1.08 1.89.846-3.386 3.837-.853a1.75 1.75 0 0 0 .67-.308zm-4.33 5.78h6.957V7.81l-1.014 1.014a1.75 1.75 0 0 1-.858.471l-3.892.865-1.194 2.09z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArea);
export default ForwardRef;